import { Toast as PicocoloToast } from '@taxdown/piccolo-web';

export const Toast = (): JSX.Element => (
  <div data-toast="true">
    <PicocoloToast />
  </div>
);
